import React from 'react';
import PropTypes from 'prop-types';
import Page from './page';
import RuleOfConduct from './RuleOfConduct';
import {publicBuildUrl} from '../../config/config';

const RulesOfConduct = ({hasNextButton = false}) => (
    <Page title={'Start or resume'}>
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            maxWidth: '1080px',
        }}>
            <div style={styles.title}>Bedankt voor je deelname!</div>
            <div className={'bodyContainer'} style={{width: '100%', maxWidth: '1080px'}}>
                <div className={'bodyContainerColumn'} style={styles.row}>
                    <img src={`${publicBuildUrl}images/EndCreditsCharacters.png`} alt={'Cast'} style={{width: '400px'}}/>
                </div>
                <div className={'bodyContainerColumn'} style={{
                    ...styles.row,
                    position: 'relative',
                }}>
                    <div style={{
                        width: '100%',
                    }}>
                        <div style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}>

                            <div><img src={`${publicBuildUrl}images/EndCreditsLogoAppstore.png`} alt={'Appstore'} style={{height: 50}}/></div>
                            <div><img src={`${publicBuildUrl}images/EndCreditsLogoGooglePlay.png`} alt={'Appstore'} style={{height: 50}}/></div>
                            <div><img src={`${publicBuildUrl}images/EndCreditsAnonymousUsage.png`} alt={'Anoniem gebruik'} style={{height: 50}}/></div>
                        </div>

                        <div style={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'center',
                            marginTop: '100px',
                        }}>
                            <div>
                                <img src={`${publicBuildUrl}images/EndCreditsLogoCareFreeOutline.png`} alt={'CareFree'} style={{width: '200px'}}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '100px'}}>
                <img src={`${publicBuildUrl}images/EndCreditsLogoNaomyRojnik.png`} alt={'CareFree'} style={styles.logo}/>
                <img src={`${publicBuildUrl}images/EndCreditsLogoProvincieLimburg.png`} alt={'CareFree'} style={styles.logo}/>
                <img src={`${publicBuildUrl}images/EndCreditsLogoBurgerkrachtLimburg.png`} alt={'CareFree'} style={styles.logo}/>
                <img src={`${publicBuildUrl}images/EndCreditsLogoSkape.png`} alt={'CareFree'} style={styles.logo}/>
                <img src={`${publicBuildUrl}images/EndCreditsLogoZapps.png`} alt={'CareFree'} style={styles.logo}/>
                <img src={`${publicBuildUrl}images/EndCreditsLogoCast.png`} alt={'CareFree'} style={styles.logo}/>
            </div>
        </div>
    </Page>
);

RuleOfConduct.propTypes = {
    hasNextButton: PropTypes.bool,
}

const styles = {
    row: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContents: 'flex-start',
    },
    title: {
        borderBottom: '9px solid #68c4d6',
        color: '#e4195f',
        display: 'flex',
        justifyContent: 'center',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
        fontSize: '48px',
        fontStyle: 'italic',
        paddingBottom: '25px',
        marginBottom: '150px',
        width: '100%',
    },
    logo: {
        height: '65px'
    }
}

export default RulesOfConduct;
